const style = theme => ({
    header: {
      display: 'flex',
      height: 60,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingLeft: 20,
      paddingRight: 20,
      backgroundColor: '#029AB1',
      color: '#FFF',
    },
    headerTitle: {
      fontSize: '1.1rem',
    },
    headerCloseIcon: {
      color: '#FFF',
    },
    bedsDashboard: {
      display: 'grid',
      height: '100vh',
      gridTemplateRows: '60px 80px auto',    
    },
    spinnerContainer: {
      flex: 1,
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      marginTop:'25vh',
      width: '100%',
      display:'grid'
    },
    spinner: {
      flex: 1,
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      display: 'grid',
      marginBottom: 20
    },
    message1: {
      gridRow: '2 / 2',
      gridColumn: '1 / 2',
      marginVertical: 40,
      marginHorizontal: 40,
      textAlign: 'center',
      paddingHorizontal: 40,
      fontSize: '1.1rem',
    },
    primaryAppBar: {
      zIndex: 2,
    },
    primaryToolBar: {
      backgroundColor: '#FFF',
    },
    primaryAppBarTitle: {
    },
    secondaryAppBar: {
      zIndex: 1,
    },
    secondaryToolbar: {
      display: 'flex',
      flexDirection: 'row',
    },
    secondaryToolBarText: {
      display: 'flex',
      boxSizing: 'border-box',
      flexDirection: 'column',
      alignItems: 'start',
      justifyContent: 'space-between',
  
    },
    secondaryToolBarButtons: {
      display: 'flex',
      boxSizing: 'border-box',
      height: '100%',
      flexDirection: 'row',
      alignItems: 'end',
      justifyContent: 'flex-end',
      flex:1,
    },
    buttonBar: {
      margin: theme.spacing(),
      fontSize:18,
    },
    secondaryAppBarTitle: {
      color: '#FFF',
      fontSize: '1.0em',
    },
    secondaryAppBarSubTitle: {
      paddingLeft: 20,
      fontSize: '1.0em',
      fontWeight: 100,
      color: '#FFF',
    },
    content: {
      display: 'grid',
      boxSizing: 'border-box',
      gridTemplateRows: '1fr',
      gridTemplateColumns: '1fr 1fr',
      gridGap: '30px',
      gridRow: '3 / 4',
      paddingLeft: '5%',
      paddingRight: '5%',
      paddingTop: 30,
      paddingBottom: 50,
    },
    contentTablet: {
      display: 'grid',
      boxSizing: 'border-box',
      gridTemplateRows: '1fr ',
      gridTemplateColumns: '1fr 1fr',
      gridGap: '30px',
      gridRow: '3 / 4',
      padding: '30px',
      height: 'calc(100vh - 60px)',
      maxHeight: 'calc(100vh - 60px)'
    },
    bedsAvailability: {
      gridRow: '1 / 2',
      gridColumn: '1 / 2',
    },
    bedsAvailabilityHistory: {
      gridRow: '1 / 2',
      gridColumn: '1 / 2',
    },
    bedsAvailabilityTablet: {
        gridRow: '1',
        gridColumn: '1 / 2 ',
      },
      bedsAvailabilityHistoryTablet: {
        gridRow: '1 ',
        gridColumn: '2 / 2',
      },
    internmentStatistics: {
      gridRow: '2 / 3',
      gridColumn: '1 / 3',
    },
  });
  
  export default style;